export const ASSET_TYPE_IMAGE = 'image'
export const ASSET_TYPE_VIDEO = 'video'

export const ACCEPTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']
